import { ApiImageClient } from "@/api";

async function apiUserGetProduct({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.get(`/products/${id}?populate=*`).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserGetProduct_Error", e);
    return e;
  }
}

async function apiUserGetProducts(
  filterField = "",
  filterValue = "",
  companyId = "",
) {
  try {
    const queries = [];

    if (filterField && filterValue) {
      queries.push(
        `filters[${filterField}][$contains]=${encodeURIComponent(filterValue)}`,
      );
    }

    if (companyId) {
      queries.push(`filters[company][documentId][$eq]=${companyId}`);
    }

    const queryString = queries.length > 0 ? queries.join("&") : "";

    const result = await ApiImageClient.get(
      `/products?populate=*&${queryString}`,
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserGetProducts_Error", e);
    return e;
  }
}
async function apiUserPostProduct({ data }: { props: any }) {
  try {
    const result = await ApiImageClient.post("/products", { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPostProduct_Error", e);
    return e;
  }
}

async function apiUserPutProducts({ id, data }) {
  try {
    const result = await ApiImageClient.put(`/products/${id}`, { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPutProducts_Error", e);
    return e;
  }
}

export {
  apiUserGetProduct,
  apiUserPutProducts,
  apiUserGetProducts,
  apiUserPostProduct,
};
